"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordionWidget = void 0;
const HtmlWidget_1 = require("./HtmlWidget");
class AccordionWidget extends HtmlWidget_1.HtmlWidget {
    constructor() {
        super("div", "");
    }
    removeAccordionSection(panel) {
        this.removeElement(panel.parentWidget, true);
    }
    addAccordionSection(name, appendChild = false, additionalData) {
        let accordionSection = this.createElement("div", div => div.classList.add("accordion-section"), appendChild);
        accordionSection.createElement("button", button => {
            button.classList.add("accordion");
            button.textContent = name;
            this.setupAccordionEvents(button);
        }, appendChild);
        let panel = accordionSection.createElement("div", element => {
            element.classList.add("panel");
            element.classList.add("form-container");
        }, appendChild);
        let accordionSectionObj = { accordionSection: accordionSection, additionalData: additionalData, panel: panel };
        if (this.accordionAdded != null) {
            this.accordionAdded(accordionSectionObj);
        }
        return accordionSectionObj;
    }
    setupAccordionEvents(accordion) {
        accordion.addEventListener("click", (evt) => {
            evt.preventDefault();
            accordion.classList.toggle("active");
            let panel = accordion.nextElementSibling;
            if (panel.style.maxHeight) {
                panel.style.maxHeight = null;
                panel.style.paddingBottom = "0";
            }
            else {
                panel.style.maxHeight = (panel.scrollHeight + 10) + "px";
                panel.style.paddingBottom = "10px";
            }
        });
    }
    shouldRender() {
        return true;
    }
}
exports.AccordionWidget = AccordionWidget;
//# sourceMappingURL=AccordionWidget.js.map